export const PROFILE_NAME = 'agroaandc';
export const isAnalyticsHidden = location.hostname !== "agricultureterminal.basf.com";
export const isAnalyticsQAHidden = location.hostname !== "agricultureterminal-qa.basf.com";